export * from './geolocalizacao-slice'